import React from 'react';
const TenderIcon = ({ color="white", ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M11.6667 10.8329L4.68254 17.8162C4.51839 17.9804 4.3235 18.1107 4.109 18.1996C3.89451 18.2885 3.6646 18.3342 3.43242 18.3343C2.9635 18.3343 2.51376 18.1481 2.18212 17.8166C1.85049 17.4851 1.66414 17.0354 1.66406 16.5665C1.66398 16.0976 1.85019 15.6478 2.18171 15.3162L9.16837 8.33203" stroke={color} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.332 13.332L18.332 8.33203" stroke={color} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M17.9167 8.7487L11.25 2.08203" stroke={color} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.66797 6.66797L11.668 1.66797" stroke={color} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.08203 6.25L13.7487 12.9167" stroke={color} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};
export default TenderIcon;
